import Image1 from "../../assets/gallery/1.jpeg";
import Image2 from "../../assets/gallery/1.jpg";
import Image3 from "../../assets/gallery/2.jpeg";
import Image4 from "../../assets/gallery/3.jpg";
import Image5 from "../../assets/gallery/3.jpeg";
import Image6 from "../../assets/gallery/4.jpg";
import Image7 from "../../assets/gallery/5.jpg";
import Image8 from "../../assets/gallery/6.jpg";
import Image9 from "../../assets/gallery/7.jpg";
import Image10 from "../../assets/gallery/8.jpg";
import Image11 from "../../assets/gallery/9.jpg";
import Image12 from "../../assets/gallery/10.jpg";
import Image13 from "../../assets/gallery/11.jpg";



const galleryData = [
  { id: 1, src: Image1, alt: "asrafulsharker 1" },
  { id: 2, src: Image2, alt: "asrafulsharker 2" },
  { id: 3, src: Image3, alt: "asrafulsharker 3" },
  { id: 4, src: Image4, alt: "asrafulsharker 4" },
  { id: 5, src: Image5, alt: "asrafulsharker 1" },
  { id: 6, src: Image6, alt: "asrafulsharker 2" },
  { id: 7, src: Image7, alt: "asrafulsharker 3" },
  { id: 8, src: Image8, alt: "asrafulsharker 4" },
  { id: 9, src: Image9, alt: "asrafulsharker 1" },
  { id: 10, src: Image10, alt: "asrafulsharker 2" },
  { id: 11, src: Image11, alt: "asrafulsharker 3" },
  { id: 12, src: Image12, alt: "asrafulsharker 4" },
  { id: 13, src: Image13, alt: "asrafulsharker 4" },
];

export default galleryData;
